import { Drawer } from "antd";
import { slice } from "lodash";
import { BsCheckSquare } from "react-icons/bs";
import Moment from "react-moment";

export default function WallBookingPanel({ isVisible, slot, setVisible }: any) {

    const data = new Array(10).fill({ id: 1 });
    let few = slice(data, 0, 10 - slot?.data?.length);
  return (
    <Drawer
      placement={"right"}
      width={700}
      onClose={() => setVisible(false)}
      visible={isVisible}
      closable={false}
      mask={false}
      bodyStyle={{ padding: "15px", backgroundColor: "#E50000" }}
      // contentWrapperStyle={{ boxShadow: "none" }}
    >
      <div className="col-span-12 sm:col-span-12 md:col-span-12 bg-toyota flex flex-col justify-start ">
        <div className="text-3xl px-2  border-gray-100 w-full text-black  mb-2 text-center flex justify-between items-center bg-white">
          <div className="truncate uppercase font-bold">
            <div className="text-black">
              <>
                {slot?.start === null ? (
                  "-"
                ) : (
                  <>
                    <Moment format="HH:mm A">{slot?.start}</Moment>
                    <span className="mx-1">-</span>
                    <Moment format="HH:mm A">{slot?.end}</Moment>
                  </>
                )}
              </>
            </div>
          </div>
          <div className="border-l border-toyota text-black font-bold py-3 text-3xl w-32">
            {slot?.data?.length} / 10
          </div>
        </div>
        <div className="">
          <div className="grid grid-cols-12 gap-x-2 gap-y-2  bg-toyota pb-2">
            {slot?.data?.map((item: any, index: number) => (
              <div
                className={`col-span-6 sm:col-span-6 md:col-span-6 border h-40 ${
                  item?.is_confirmed ? "bg-green-100" : "bg-red-100"
                }`}
                key={index}
              >
                <div className="flex flex-col justify-center mx-2 py-3 text-gray-800 text-left truncate">
                  <div className="text-4xl font-bold">{item?.vehicle}</div>
                  <div className="text-2xl text-gray-600">
                    {item?.customer_name}
                  </div>
                  <div className="flex">
                    {item?.is_confirmed ? (
                      <div className="text-status-green font-bold py-1 text-center flex items-center justify-center">
                        <BsCheckSquare />
                        <span className="ml-1">CONFIRMED</span>
                      </div>
                    ) : (
                      <div className="text-status-red font-bold py-1 text-center">
                        <span>UNCONFIRMED</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {few?.map((_, index: number) => (
              <div
                className="col-span-6 sm:col-span-6 md:col-span-6 bg-gray-200 border h-40"
                key={index}
              >
                <div className="flex flex-1 w-full h-full justify-center items-center text-gray-500 text-xl">
                  AVAILABLE SLOT
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
